export default class InvoiceCount {
    static fromData(data) {
        if (!data) {
            return;
        }

        const invoiceCount = new InvoiceCount();
        invoiceCount.count = data.count;

        return invoiceCount;
    }
}
